// frontend/src/pages/partnerships/Partnerships.jsx

import React, { useState } from "react";
import "./partnerships.css";
import { Link } from "react-router-dom";

export default function Partnerships() {
  const [selectedType, setSelectedType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const form = e.target;

    const data = {
      name: form.name.value,
      email: form.email.value,
      organization: form.organization.value,
      message: form.message.value,
      type: form.type.value,
      otherTypeDetail:
        form.type.value === "other" ? form.otherTypeDetail.value.trim() : "",
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_API}partnerships`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        window.location.href = "/partnerships-thank-you";
      } else {
        const err = await res.json();
        alert(`Error: ${err.message || "Something went wrong."}`);
      }
    } catch (err) {
      console.error(err);
      alert("Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="partnerships-container">
      <section className="partnerships-hero">
        <h1>Partner With Us</h1>
        <p>
          We work with aligned organizations on custom partnerships: retail placements, bulk access, co-marketing, and member benefits.
        </p>

        <p style={{ marginTop: "15px" }}>
          If you’re an influencer, blogger, newsletter publisher or community looking for a promo code, apply here:{" "}
          <Link to="/affiliate-program">Affiliate Program</Link>.
        </p>

      </section>
      <section className="partnerships-section">
        <h2>Custom Partnership Model</h2>
        <p>
          We work with organizations on bulk access, member benefits, co-marketing, and retail placements. Terms are customized per partner.
        </p>
      </section>
      <section className="partnerships-section">
        <h2>Ways to Partner With Us</h2>
        <ul>
          <li><strong>Retail / Checkout Placements</strong> – Offer FLOW subscriptions at point-of-sale, post-purchase, or receipts with custom tracking and revenue share.</li>
          <li><strong>Bulk Access</strong> – Subscriptions for members, staff, students, or customers at negotiated pricing.</li>
          <li><strong>Member Benefits / Bundles</strong> – FLOW included as a perk inside your membership or bundle.</li>
          <li><strong>Co-Marketing</strong> – Newsletter swaps, campaigns, or curated collections with shared reporting.</li>
        </ul>
      </section>
      <section className="partnerships-section">
        <h2>How It Works</h2>
        <ol>
          <li><strong>Submit details</strong> – Tell us your audience, channel, and what partnership you’re considering.</li>
          <li><strong>We propose terms</strong> – Bulk seats, member discounts, bundles, co-marketing, or retail placements.</li>
          <li><strong>We launch & track</strong> – We set up tracking, assets, and a simple reporting cadence.</li>
        </ol>
      </section>
      <section className="partnerships-section">
        <h2>Why This Works for Partners</h2>
        <ul>
          <li>
            <strong>Immediate value for your audience</strong>
            <div>
              You offer a meaningful benefit (discounted or included access to a high-quality publication) without building or managing anything yourself.
            </div>
          </li>

          <li>
            <strong>Incremental revenue with minimal operational overhead</strong>
            <div>
              No inventory, no fulfillment, and lightweight setup — designed to layer onto how you already operate.
            </div>
          </li>

          <li>
            <strong>Flexible partnership structures</strong>
            <div>
              Works equally well for bulk access, member perks, retail placements, or co-marketing — structured to fit your existing model.
            </div>
          </li>

          <li>
            <strong>Aligned incentives, not traditional ads</strong>
            <div>
              Whether through revenue share, bundled access, or negotiated terms, value is delivered before anyone gets paid.
            </div>
          </li>

          <li>
            <strong>Scales with trust, not volume</strong>
            <div>
              The more your audience trusts you, the better this performs — no pressure to “push,” no risk to your brand.
            </div>
          </li>
        </ul>
      </section>
      <section className="partnerships-section">
        <h2>Ready to Collaborate?</h2>
        <p style={{ marginBottom: "15px" }}>
          Tell us what partnership you’re proposing. We’ll review and follow up with next steps.
        </p>

        <form className="partnerships-form" onSubmit={handleSubmit} autoComplete="off">
          <label>
            Name*
            <input type="text" name="name" required />
          </label>
          <label>
            Email*
            <input type="email" name="email" required />
          </label>
          <label>
            Organization (optional)
            <input type="text" name="organization" />
          </label>
          <label>
            What kind of partnership are you proposing?*
            <select
              name="type"
              defaultValue=""
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              required
            >
              <option value="" disabled hidden>Select one...</option>
              <option value="retail">Retail / Checkout Placement</option>
              <option value="bulk">Bulk Access (Members, Staff, Customers)</option>
              <option value="education">Educational Institution</option>
              <option value="nonprofit">Nonprofit / Community Organization</option>
              <option value="co_marketing">Co-Marketing / Media Partner</option>
              <option value="other">Other / Not Sure</option>
            </select>
          </label>
          {selectedType === "other" && (
            <label>
              Please describe your partnership type<span aria-hidden="true">*</span>
              <input type="text" name="otherTypeDetail" required minLength={3} />
            </label>
          )}
          <label>
            Tell us about your organization and what partnership you’re proposing.*
            <textarea name="message" rows="5" required />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Submit Partnership Request"}
          </button>
        </form>
      </section>

      <div className="back-link">
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}
